const borderRadiusSmall = "4px";
const borderRadiusMedium = "8px";
const borderRadiusRegular = "12px";
const borderRadiusLarge = "16px";
const borderWidthSmall = "1px";
const borderWidthMedium = "2px";
const borderWidthLarge = "4px";
const breakpointSmall = 600;
const breakpointMedium = 1200;
const breakpointLarge = 1500;
const breakpointLargeX = 1900;
const colorBrandPrimary50 = "#feeee9";
const colorBrandPrimary100 = "#fcd5c8";
const colorBrandPrimary200 = "#f9ac92";
const colorBrandPrimary300 = "#f5835b";
const colorBrandPrimary400 = "#f25924";
const colorBrandPrimary500 = "#b2421b";
const colorBrandPrimary600 = "#732b11";
const colorBrandSecondary50 = "#efe7ea";
const colorBrandSecondary100 = "#d7c3cb";
const colorBrandSecondary200 = "#ae8796";
const colorBrandSecondary300 = "#864b62";
const colorBrandSecondary400 = "#5e0f2e";
const colorBrandSecondary500 = "#460b22";
const colorBrandSupport01100 = "#f7f4fd";
const colorBrandSupport01200 = "#ece3fb";
const colorBrandSupport01300 = "#d9c7f7";
const colorBrandSupport01400 = "#c6abf4";
const colorBrandSupport01500 = "#b38ff0";
const colorBrandSupport01550 = "#7d5eb0";
const colorBrandSupport01600 = "#5e4b7d";
const colorBrandSupport0250 = "#fff3ea";
const colorBrandSupport02100 = "#ffe1cb";
const colorBrandSupport02200 = "#ffc397";
const colorBrandSupport02300 = "#ffa463";
const colorBrandSupport02400 = "#ff862f";
const colorBrandSupport02500 = "#b25800";
const colorBrandSupport02600 = "#663200";
const colorBrandSupport0350 = "#fdfdfe";
const colorBrandSupport03100 = "#f9f9fc";
const colorBrandSupport03200 = "#f4f4f9";
const colorBrandSupport03300 = "#eeeef6";
const colorBrandSupport03400 = "#e9e9f3";
const colorBrandSupport03500 = "#d4d4e8";
const colorFeedbackError100 = "#feeaea";
const colorFeedbackError200 = "#fcc0c0";
const colorFeedbackError300 = "#f07575";
const colorFeedbackError400 = "#d02525";
const colorFeedbackError500 = "#910808";
const colorFeedbackError600 = "#570f0f";
const colorFeedbackWarning100 = "#fdf5dd";
const colorFeedbackWarning200 = "#fbeab6";
const colorFeedbackWarning300 = "#f9dc86";
const colorFeedbackWarning400 = "#ebc247";
const colorFeedbackWarning500 = "#a16512";
const colorFeedbackWarning600 = "#5c2e00";
const colorFeedbackSuccess50 = "#ebf9ed";
const colorFeedbackSuccess100 = "#d7f3db";
const colorFeedbackSuccess200 = "#b0e8b7";
const colorFeedbackSuccess300 = "#86dc91";
const colorFeedbackSuccess400 = "#3fa64d";
const colorFeedbackSuccess500 = "#22772e";
const colorFeedbackSuccess600 = "#0b3210";
const colorFeedbackInfo50 = "#f3f6fc";
const colorFeedbackInfo100 = "#ebf0fa";
const colorFeedbackInfo200 = "#adc2eb";
const colorFeedbackInfo300 = "#7095db";
const colorFeedbackInfo400 = "#406bbf";
const colorFeedbackInfo500 = "#24488e";
const colorFeedbackInfo600 = "#0f2857";
const colorNeutral0 = "#ffffff";
const colorNeutral50 = "#f4f4f5";
const colorNeutral300 = "#eaeaef";
const colorNeutral400 = "#dcdbdf";
const colorNeutral500 = "#bcbcc1";
const colorNeutral600 = "#8c8b93";
const colorNeutral700 = "#6e6b75";
const colorNeutral800 = "#53525d";
const colorNeutral900 = "#383842";
const colorNeutral1000 = "#191826";
const colorSupport01100 = "#fff5fb";
const colorSupport01200 = "#ffd1ee";
const colorSupport01300 = "#ff85d1";
const colorSupport01400 = "#ff38b4";
const colorSupport01500 = "#eb0093";
const colorSupport01600 = "#9e0063";
const colorSupport02100 = "#f9e6ff";
const colorSupport02200 = "#e699ff";
const colorSupport02300 = "#d44dff";
const colorSupport02400 = "#c100ff";
const colorSupport02500 = "#8700b2";
const colorSupport02600 = "#4d0066";
const colorSupport03100 = "#fcd5c8";
const colorSupport03200 = "#f9ac92";
const colorSupport03300 = "#f5835b";
const colorSupport03400 = "#f25924";
const colorSupport03500 = "#b2421b";
const colorSupport03600 = "#732b11";
const colorSupport04100 = "#e6f9ff";
const colorSupport04200 = "#99e6ff";
const colorSupport04300 = "#4dd4ff";
const colorSupport04400 = "#00c1ff";
const colorSupport04500 = "#0087b2";
const colorSupport04600 = "#004d66";
const colorTransparent0Low = "#ffffff";
const colorTransparent0Medium = "#ffffff";
const colorTransparent0High = "#ffffff";
const colorTransparent1000Low = "#181818";
const colorTransparent1000Medium = "#181818";
const colorTransparent1000High = "#181818";
const fontFamilyBody = "'DM Sans', sans-serif";
const fontFamilyTitle = "'DM Sans', sans-serif";
const fontSizeSmallX = "1.2rem";
const fontSizeSmall = "1.4rem";
const fontSizeRegular = "1.6rem";
const fontSizeMedium = "2rem";
const fontSizeLarge = "2.4rem";
const fontSizeLargeX = "2.8rem";
const fontSizeLargeXx = "3.2rem";
const fontSizeLargeXxx = "4rem";
const fontSizeLargeXxxx = "4.8rem";
const fontWeightRegular = 400;
const fontWeightMedium = 500;
const fontWeightSemibold = 600;
const fontWeightBold = 700;
const lineHeightSmall = 1;
const lineHeightRegular = 1.5;
const outlineColorBase = "#b38ff0";
const outlineColorInverted = "#ece3fb";
const outlineStyle = "dotted";
const outlineWidth = "2px";
const shadowSmall = "0px 1px 2px hsla(0, 0%, 9%, 0.32)";
const shadowMedium = "0px 2px 4px hsla(0, 0%, 9%, 0.32)";
const shadowLarge = "0px 4px 6px hsla(0, 0%, 9%, 0.32)";
const shadowLargeX = "0px 6px 16px hsla(0, 0%, 9%, 0.4)";
const shadowTopSmall = "0px -3px 2px -2px hsla(0, 0%, 9%, 0.32)";
const shadowTopMedium = "0px -6px 4px -4px hsla(0, 0%, 9%, 0.32)";
const shadowTopLarge = "0px -10px 6px -6px hsla(0, 0%, 9%, 0.32)";
const shadowTopLargeX = "0px -22px 16px -18px hsla(0, 0%, 9%, 0.4)";
const shadowBottomSmall = "0px 3px 2px -2px hsla(0, 0%, 9%, 0.32)";
const shadowBottomMedium = "0px 6px 4px -4px hsla(0, 0%, 9%, 0.32)";
const shadowBottomLarge = "0px 10px 6px -6px hsla(0, 0%, 9%, 0.32)";
const shadowBottomLargeX = "0px 22px 16px -18px hsla(0, 0%, 9%, 0.4)";
const spaceSmallXxx = "4px";
const spaceSmallXx = "8px";
const spaceSmallX = "12px";
const spaceRegular = "16px";
const spaceMedium = "24px";
const spaceLarge = "32px";
const spaceLargeX = "40px";
const spaceLargeXx = "48px";
const spaceLargeXxx = "56px";
const timeDelayShort = "50ms";
const timeDelayBase = "130ms";
const timeDelayLong = "200ms";
const timeTransitionShort = "150ms";
const timeTransitionBase = "250ms";
const timeTransitionLong = "450ms";
const zindexLevel100 = 1e3;
const zindexLevel200 = 1020;
const zindexLevel300 = 1030;
const zindexLevel400 = 1040;
const zindexLevel500 = 1050;
const zindexLevel600 = 1060;
const zindexLevel700 = 1070;
const zindexLevel800 = 1080;
const zindexLevel900 = 1090;
const zindexLevel1000 = 1100;
const zindexLevelDown1 = -1;
export {
  borderRadiusLarge,
  borderRadiusMedium,
  borderRadiusRegular,
  borderRadiusSmall,
  borderWidthLarge,
  borderWidthMedium,
  borderWidthSmall,
  breakpointLarge,
  breakpointLargeX,
  breakpointMedium,
  breakpointSmall,
  colorBrandPrimary100,
  colorBrandPrimary200,
  colorBrandPrimary300,
  colorBrandPrimary400,
  colorBrandPrimary50,
  colorBrandPrimary500,
  colorBrandPrimary600,
  colorBrandSecondary100,
  colorBrandSecondary200,
  colorBrandSecondary300,
  colorBrandSecondary400,
  colorBrandSecondary50,
  colorBrandSecondary500,
  colorBrandSupport01100,
  colorBrandSupport01200,
  colorBrandSupport01300,
  colorBrandSupport01400,
  colorBrandSupport01500,
  colorBrandSupport01550,
  colorBrandSupport01600,
  colorBrandSupport02100,
  colorBrandSupport02200,
  colorBrandSupport02300,
  colorBrandSupport02400,
  colorBrandSupport0250,
  colorBrandSupport02500,
  colorBrandSupport02600,
  colorBrandSupport03100,
  colorBrandSupport03200,
  colorBrandSupport03300,
  colorBrandSupport03400,
  colorBrandSupport0350,
  colorBrandSupport03500,
  colorFeedbackError100,
  colorFeedbackError200,
  colorFeedbackError300,
  colorFeedbackError400,
  colorFeedbackError500,
  colorFeedbackError600,
  colorFeedbackInfo100,
  colorFeedbackInfo200,
  colorFeedbackInfo300,
  colorFeedbackInfo400,
  colorFeedbackInfo50,
  colorFeedbackInfo500,
  colorFeedbackInfo600,
  colorFeedbackSuccess100,
  colorFeedbackSuccess200,
  colorFeedbackSuccess300,
  colorFeedbackSuccess400,
  colorFeedbackSuccess50,
  colorFeedbackSuccess500,
  colorFeedbackSuccess600,
  colorFeedbackWarning100,
  colorFeedbackWarning200,
  colorFeedbackWarning300,
  colorFeedbackWarning400,
  colorFeedbackWarning500,
  colorFeedbackWarning600,
  colorNeutral0,
  colorNeutral1000,
  colorNeutral300,
  colorNeutral400,
  colorNeutral50,
  colorNeutral500,
  colorNeutral600,
  colorNeutral700,
  colorNeutral800,
  colorNeutral900,
  colorSupport01100,
  colorSupport01200,
  colorSupport01300,
  colorSupport01400,
  colorSupport01500,
  colorSupport01600,
  colorSupport02100,
  colorSupport02200,
  colorSupport02300,
  colorSupport02400,
  colorSupport02500,
  colorSupport02600,
  colorSupport03100,
  colorSupport03200,
  colorSupport03300,
  colorSupport03400,
  colorSupport03500,
  colorSupport03600,
  colorSupport04100,
  colorSupport04200,
  colorSupport04300,
  colorSupport04400,
  colorSupport04500,
  colorSupport04600,
  colorTransparent0High,
  colorTransparent0Low,
  colorTransparent0Medium,
  colorTransparent1000High,
  colorTransparent1000Low,
  colorTransparent1000Medium,
  fontFamilyBody,
  fontFamilyTitle,
  fontSizeLarge,
  fontSizeLargeX,
  fontSizeLargeXx,
  fontSizeLargeXxx,
  fontSizeLargeXxxx,
  fontSizeMedium,
  fontSizeRegular,
  fontSizeSmall,
  fontSizeSmallX,
  fontWeightBold,
  fontWeightMedium,
  fontWeightRegular,
  fontWeightSemibold,
  lineHeightRegular,
  lineHeightSmall,
  outlineColorBase,
  outlineColorInverted,
  outlineStyle,
  outlineWidth,
  shadowBottomLarge,
  shadowBottomLargeX,
  shadowBottomMedium,
  shadowBottomSmall,
  shadowLarge,
  shadowLargeX,
  shadowMedium,
  shadowSmall,
  shadowTopLarge,
  shadowTopLargeX,
  shadowTopMedium,
  shadowTopSmall,
  spaceLarge,
  spaceLargeX,
  spaceLargeXx,
  spaceLargeXxx,
  spaceMedium,
  spaceRegular,
  spaceSmallX,
  spaceSmallXx,
  spaceSmallXxx,
  timeDelayBase,
  timeDelayLong,
  timeDelayShort,
  timeTransitionBase,
  timeTransitionLong,
  timeTransitionShort,
  zindexLevel100,
  zindexLevel1000,
  zindexLevel200,
  zindexLevel300,
  zindexLevel400,
  zindexLevel500,
  zindexLevel600,
  zindexLevel700,
  zindexLevel800,
  zindexLevel900,
  zindexLevelDown1
};
